import { render } from "./basePassword.vue?vue&type=template&id=a62fd248&scoped=true"
import script from "./basePassword.vue?vue&type=script&lang=js"
export * from "./basePassword.vue?vue&type=script&lang=js"

import "./basePassword.vue?vue&type=style&index=0&id=a62fd248&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a62fd248"]])

export default __exports__